import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const ContactPage = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSubmissions = async () => {
    try {
      const res = await axios.get(
        "https://api.themysoreoils.com/api/admin/contacts"
      );

      if (res.data.success) {
        setSubmissions(res.data.data);
      } else {
        setSubmissions([]);
      }

      setLoading(false);
    } catch (err) {
      console.error("Failed to fetch contact forms", err);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this submission?"
    );

    if (!confirmDelete) return;

    try {
      const res = await axios.delete(
        `https://api.themysoreoils.com/api/admin/contacts/${id}`
      );

      if (res.data.success) {
        alert("Deleted successfully");
        fetchSubmissions(); // Refresh list
      }
    } catch (error) {
      console.error("Delete failed", error);
      alert("Delete failed");
    }
  };

  useEffect(() => {
    fetchSubmissions();
  }, []);

  return (
    <div className="container py-5">
      <div
        className="card shadow-lg border-0 rounded-4 p-4"
        style={{ width: "100%" }}
      >
        <h2 className="text-center fw-bold mb-4">
          Contact Form Submissions
        </h2>

        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : submissions.length === 0 ? (
          <p className="text-center text-muted">
            No submissions found.
          </p>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle text-center">
              <thead className="table-dark">
                <tr>
                  <th>Sl. No</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Message</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {submissions.map((entry, index) => (
                  <tr key={entry._id}>
                    <td>{index + 1}</td>
                    <td>{entry.firstName}</td>
                    <td>{entry.lastName}</td>
                    <td>{entry.email}</td>
                    <td>
                      {entry.phoneCode} {entry.phoneNumber}
                    </td>
                    <td>{entry.message}</td>
                    <td>
                      {new Date(entry.createdAt).toLocaleDateString()}
                    </td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(entry._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPage;